import axios from '../components/_generic/axiosSplunk/axiosSplunk';
import httpCommonHeaders from './httpCommonHeaders';

const travelService = {};

/**
 * Call API to instant redeem
 *
 * @param {number} productOrderId - order details information object
 * @returns {Service}
 */
travelService.instantRedeem = (productOrderId) => {
  if (!productOrderId) return;

  return axios(
    `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/flights/voucher/redeem/${productOrderId}`,
    {
      cache: false,
      headers: httpCommonHeaders(),
      method: 'GET',
      withCredentials: true,
    },
  );
};

travelService.getPassengerDetails = (productOrderId, productId) => {
  if (!productOrderId || !productId) return;

  return axios(
    `${process.env.NEXT_PUBLIC_PUBLIC_API}/v1/flights/passenger/${productOrderId}/${productId}`,
    {
      cache: false,
      headers: httpCommonHeaders(),
      method: 'GET',
      withCredentials: true,
    },
  );
};

export default travelService;
